import * as React from "react";
import { observer } from "mobx-react";
import { SpedApuracaoStore } from "../../stores/sped/SpedApuracaoStore";
import { Alignment, Button, Classes, Dialog, FormGroup, HTMLSelect } from "@blueprintjs/core";
import { MDBCol, MDBRow } from "mdbreact";
import { observable } from "mobx";
import { formatCnpj } from "../../utils";
import { IEmpresa, newEmpresa } from "../../model";
import { toast } from "react-toastify";
import { EmpresaSelect, filterEmpresa, renderEmpresa } from "../empresa/EmpresaSelect";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ptBR } from '@mui/x-date-pickers/locales';
import moment from "moment";
import { AppStore } from "../../stores/AppStore";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import dayjs from "dayjs";
import ApuracaoEntradaTable from "./ApuracaoEntradaTable";
import { LookupStore } from "../../stores/LookupStore";
import Cookies from 'universal-cookie';
import { SpedStore } from "../../stores/sped/SpedStore";

const cookies = new Cookies()

@observer
export default class ApuracaoEntrada extends React.Component<{}, {}> {

  obs = observable({})

  constructor(props: any) {
    super(props);

  }

  /**
   * Ao montar o componente, verifica se existe o cookie "__DAE-DEI".
   * Se existir, restaura as informações salvas (abas, empresa, período,
   * modelo e data) nos stores e realiza a busca de dados DEI.
   * Após isso, o cookie é removido.
   */
  async componentDidMount() {

    const cookies_data = cookies.get('__DAE-DEI');

    if (cookies_data && cookies_data.tab == "apuracao_entrada") {

      SpedStore.obs.selectedTab = "apuracao"

      SpedApuracaoStore.obs.selectedTab = "apuracao_entrada"

      SpedApuracaoStore.obs.selectedEmpresaEntrada = cookies_data.empresa

      SpedApuracaoStore.obs.periodoEntrada = cookies_data.periodo

      SpedApuracaoStore.obs.modelo = cookies_data.modelo

      SpedApuracaoStore.obs.dataEntrada = dayjs(moment(cookies_data.date_start).add(3, "hours").toDate())

      await LookupStore.loadIcmsClassificacoes(SpedApuracaoStore.obs.selectedEmpresaEntrada.uf);

      await SpedApuracaoStore.handleBuscaApuracaoEntrada(SpedApuracaoStore.obs.selectedEmpresaEntrada, SpedApuracaoStore.obs.periodoEntrada, SpedApuracaoStore.obs.modelo)

      cookies.remove('__DAE-DEI');

    }

  }

  /**
 * Realiza a busca da apuração de ICMS, verificando as condições necessárias antes de efetuar a requisição de dados.
 * 
 * A função verifica os seguintes itens:
 * - Se a empresa foi selecionada (CNPJ).
 * - Se o período de apuração é válido.
 * - Se o ano do período de apuração é válido (não inferior a 2000).
 * - Se a UF da empresa foi selecionada.
 * 
 * Caso alguma dessas condições não seja atendida, a execução é interrompida com o devido tratamento, como exibição de mensagens de aviso.
 * 
 * Após a validação, a função realiza duas operações assíncronas:
 * 1. Carrega as classificações de ICMS para a UF da empresa selecionada.
 * 2. Busca os dados de apuração para a empresa e período selecionados.
 * 
 * @returns {Promise<void>} Retorna uma promise que resolve sem valor após a execução das operações assíncronas. Não há valor de retorno, pois a função apenas realiza a busca e manipulação de dados de apuração.
 */
  async handleBuscaApuracao() {

    if (!SpedApuracaoStore.obs.selectedEmpresaEntrada.cnpj) {
      toast.warning('Selecione uma empresa.', {});
      return
    }

    if (!SpedApuracaoStore.obs.periodoEntrada || SpedApuracaoStore.obs.periodoEntrada.includes("Data inválida") || SpedApuracaoStore.obs.periodoEntrada.includes(null) || SpedApuracaoStore.obs.periodoEntrada.includes("")) {
      return
    }

    if (parseInt(moment(SpedApuracaoStore.obs.periodoEntrada[0]).format("YYYY")) < 2000) return
    if (parseInt(moment(SpedApuracaoStore.obs.periodoEntrada[0]).format("YYYY")) < 2000) return

    await LookupStore.loadIcmsClassificacoes(SpedApuracaoStore.obs.selectedEmpresaEntrada.uf);

    await SpedApuracaoStore.handleBuscaApuracaoEntrada(SpedApuracaoStore.obs.selectedEmpresaEntrada, SpedApuracaoStore.obs.periodoEntrada, SpedApuracaoStore.obs.modelo)

  }

  /**
 * Atualiza o período de apuração com base no valor recebido e aciona a busca de apuração.
 * 
 * A função realiza a seguinte operação:
 * - Recebe um valor (provavelmente um objeto de data) e extrai a data do valor, caso seja válida.
 * - Atualiza a propriedade `dataEntrada` no `SpedApuracaoStore`.
 * - Calcula o período de início e fim do mês da data recebida, formatando os valores no formato "YYYY-MM-DD".
 * - Atualiza a propriedade `periodoEntrada` no `SpedApuracaoStore` com as novas datas de início e fim do mês.
 * - Chama a função `handleBuscaApuracao` para buscar os dados de apuração com base nas novas configurações de período.
 * 
 * @param {Object} value O valor da data, que pode ser um objeto de data (como um objeto Moment.js ou similar) com uma propriedade `$d`.
 * 
 * @returns {Promise<void>} Retorna uma promise que resolve sem valor após a execução da busca de apuração.
 */
  async handlePeriodo(value) {

    const data = value && value.$d ? value.$d : ""

    SpedApuracaoStore.obs.dataEntrada = value

    SpedApuracaoStore.obs.periodoEntrada = [moment(data).startOf("month").format("YYYY-MM-DD"), moment(data).endOf("month").format("YYYY-MM-DD")]

    this.handleBuscaApuracao()

  }

  /**
 * Atualiza o modelo de apuração e aciona a busca de apuração.
 * 
 * A função recebe um modelo como parâmetro, atualiza o valor do modelo no `SpedApuracaoStore` e chama a função de busca de apuração (`handleBuscaApuracao`) para obter os dados com base no modelo atualizado.
 * 
 * @param {string} modelo O modelo de apuração a ser definido. Este valor será armazenado em `SpedApuracaoStore.obs.modelo`.
 * 
 * @returns {Promise<void>} Retorna uma promise que resolve sem valor após a execução da busca de apuração.
 */
  handleChangeModelo(modelo: string) {

    SpedApuracaoStore.obs.modelo = modelo

    this.handleBuscaApuracao()

  }

  render() {

    let empresaText = SpedApuracaoStore.obs.selectedEmpresaEntrada.cnpj != ""
      ? `${SpedApuracaoStore.obs.selectedEmpresaEntrada.razao_social.substring(0, 38)}... (${formatCnpj(SpedApuracaoStore.obs.selectedEmpresaEntrada.cnpj)})`
      : "Selecione uma empresa";

    return (
      <>

        <MDBRow style={{ display: "flex", width: "100%", marginBottom: "10px" }}>

          <MDBCol md="4">
            <FormGroup className="empresaSelect" label="Empresa">
              <EmpresaSelect
                items={EmpresaStore.sortedEmpresas}
                itemRenderer={renderEmpresa}
                itemPredicate={filterEmpresa}
                onItemSelect={(e: IEmpresa) => { SpedApuracaoStore.obs.selectedEmpresaEntrada = e; this.handleBuscaApuracao() }}
                inputProps={{ placeholder: "Filtrar uma empresa" }}
              >
                <Button
                  text={empresaText}
                  rightIcon="double-caret-vertical"
                  alignText={Alignment.LEFT}
                />
              </EmpresaSelect>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup label="Período">
              <LocalizationProvider
                localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
                adapterLocale={"pt-br"}
                dateAdapter={AdapterDayjs}>
                <DatePicker value={SpedApuracaoStore.obs.dataEntrada} className="input-data-apuracao" views={['month', 'year']} onChange={(value) => this.handlePeriodo(value)} format="MM/YYYY" slotProps={{ textField: { size: 'small' } }} />
              </LocalizationProvider>
            </FormGroup>
          </MDBCol>

          <MDBCol md="2">
            <FormGroup label="Modelo">
              <HTMLSelect
                onChange={(e) => this.handleChangeModelo(e.target.value)}
                value={SpedApuracaoStore.obs.modelo}
              >
                <option value="NF-E">NF-E</option>
                <option value="NFC-E">NFC-E</option>
                <option value="CT-E">CT-E</option>
                <option value="NFS-E">NFS-E</option>
              </HTMLSelect>
            </FormGroup>
          </MDBCol>

        </MDBRow>

        {SpedApuracaoStore.obs.apuracoes_entrada ?

          <ApuracaoEntradaTable item={SpedApuracaoStore.obs.apuracoes_entrada} />

          : <></>

        }

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }} />

      </>
    )
  }
}